import { render, staticRenderFns } from "./SchoolInfoList.vue?vue&type=template&id=f38ecc68&scoped=true"
import script from "./SchoolInfoList.vue?vue&type=script&lang=js"
export * from "./SchoolInfoList.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfoList.vue?vue&type=style&index=0&id=f38ecc68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ecc68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38ecc68')) {
      api.createRecord('f38ecc68', component.options)
    } else {
      api.reload('f38ecc68', component.options)
    }
    module.hot.accept("./SchoolInfoList.vue?vue&type=template&id=f38ecc68&scoped=true", function () {
      api.rerender('f38ecc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolInfo/SchoolInfoList.vue"
export default component.exports